import { read, utils } from 'xlsx';

// Limite de tamanho da planilha de importacao em massa, conferido antes de ler o arquivo.
export const MAX_VEHICLES_SHEET_SIZE = 5 * 1024 * 1024;

// Le a primeira aba da planilha enviada pelo usuario. Opcoes conforme a SheetJS para
// arquivo nao confiavel: sem formulas, sem HTML e so a primeira aba. Lanca erro se o
// arquivo nao puder ser lido; quem chama deve tratar. Retorna null se nao houver aba.
export function readVehiclesSheet(data: ArrayBuffer): any[] | null {
  const wb = read(data, {
    type: 'array',
    cellFormula: false,
    cellHTML: false,
    sheets: 0,
  });
  const sheets = wb.SheetNames;

  if (!sheets.length || !wb.Sheets[sheets[0]]) return null;

  return utils.sheet_to_json(wb.Sheets[sheets[0]]);
}
